import { withTransaction } from '@elastic/apm-rum-react'
import { Campaign, LogService, ModalAcceptanceContract, SheHulkService, UserInDetails } from '@hub/shared'
import { SqBorderWithIcon, SqLoader } from '@squidit/react-css'
import BrandRequirements from '@src/components/brand-requirements/brand-requirements.component'
import CanReceiveComponent from '@src/components/can-receive/can-receive.component'
import ElementClickableComponent from '@src/components/element-clickable/element-clickable.component'
import { useCallback, useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import './detailing.page.scoped.scss'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  campaign: Campaign
  userInCampaign: UserInDetails
}

const DetailingPageComponent = ({ campaign, userInCampaign }: Props) => {
  const [t] = useTranslation('campaignDetailing')
  const logService = useMemo(() => new LogService(), [])
  const sheHulkService = useMemo(() => new SheHulkService(), [])
  const [contract, setContract] = useState(null)
  const [loadingContract, setLoadingContract] = useState(false)
  const [openModal, setOpenModal] = useState(false)

  const onDownloadContract = useCallback(async () => {
    try {
      setLoadingContract(true)
      sheHulkService
        .getAcceptedContract(campaign._id, userInCampaign?.idNetwork)
        .then((resp) => {
          setContract(resp?.contract)
        })
        .catch((error) => {
          logService.error({ message: error.message, error })
        })
        .finally(() => {
          setLoadingContract(false)
        })
    } catch (err) {
      setLoadingContract(false)
    }
  }, [campaign, setLoadingContract, sheHulkService, logService, userInCampaign?.idNetwork])

  const parseContract = (contract) => {
    return (contract = contract?.replace(/<style\b[^<>]*>[\s\S]*?<\/style\s*>/gi, '') || '')
  }

  useEffect(() => {
    onDownloadContract()
  }, [onDownloadContract])

  logService.init('Campaign Detailing Page')

  return (
    <section>
      <div className="mb-3">
        <p className="clean-style" dangerouslySetInnerHTML={{ __html: campaign?.activation?.description }}></p>
      </div>
      <hr />
      <div className="mt-3">
        <h6>{t('brandTitle')}</h6>
        <p className="clean-style" dangerouslySetInnerHTML={{ __html: campaign?.activation?.clientDescription }}></p>
      </div>
      <hr />
      <BrandRequirements className="mt-3" scope={userInCampaign?.scope || null} />
      <hr />
      <CanReceiveComponent className="mt-3" campaign={campaign} user={userInCampaign} />

      {loadingContract ? (
        <div className="display-flex justify-content-center">
          <SqLoader size="small" />
        </div>
      ) : contract ? (
        <ElementClickableComponent
          title={t('seeContract')}
          fileDownload={contract}
          rightIcon="fa-regular fa-eye"
          action={() => setOpenModal(true)}
        />
      ) : null}
      {campaign?.isTcm ? (
        <div className="campaing-ttcm">
          <SqBorderWithIcon title={t('important')}>
            <p dangerouslySetInnerHTML={{ __html: t('textTCM') }}></p>
          </SqBorderWithIcon>
        </div>
      ) : null}
      <ModalAcceptanceContract
        modalTitle={t('seeContract')}
        openModal={openModal}
        contract={contract ? parseContract(contract) : ''}
        loading={loadingContract}
        closeModal={() => setOpenModal(false)}
        acceptTerms={[]}
      />
    </section>
  )
}

export default withTransaction('DetailingPageComponent', 'component')(DetailingPageComponent)
